export { default } from "./SimpleFormModal";
